import type { InventoryItemSchema, ProductPrefixSchema } from "@jti/evo-client";
import type { Device } from "@jti/rest-api-types";

type DevicePrefixExtended = ProductPrefixSchema & {
  product_family?: string;
};

export const getDeviceDataFromEvoResponse = (deviceData?: InventoryItemSchema, isGuestRegistration = false): Device => {
  const userIdKey = isGuestRegistration ? "external_user_id" : "des_user_id";
  const devicePrefix = deviceData?.product_prefix as DevicePrefixExtended | null | undefined;

  return {
    productType: devicePrefix?.product_family ?? devicePrefix?.product_type ?? deviceData?.type ?? "",
    isVirtual: deviceData?.is_virtual ?? false,
    deviceId: deviceData?.serial_code ?? deviceData?.user_code ?? deviceData?.leaflet_code ?? "",
    externalId: deviceData?.product_sku ?? "",
    productId: deviceData?.serial_code ?? deviceData?.user_code ?? "",
    tenantCode: deviceData?.tenant_code ?? "",
    deviceName: deviceData?.product?.name ?? "",
    countryCode: deviceData?.country_code ?? "",
    iotTenantCode: deviceData?.tenant_code ?? "",
    tenantCodeString: deviceData?.tenant_code ?? "",
    userId: deviceData?.current_owner?.[userIdKey] ?? "",
    productVersion: deviceData?.product_prefix?.prefix ?? "",
    consumerId: deviceData?.current_owner?.[userIdKey] ?? "",
    productColor: deviceData?.product_prefix?.product_color ?? "",
    warrantyExpiryDate: deviceData?.warranty?.expiration_date ?? "",
    registrationDate: deviceData?.current_registration?.registration_date ?? "",
    userAssignmentDate: deviceData?.current_registration?.registration_date ?? "",
    randomCode: "", // Evo does not provide this info
    trackingCode: "", // Evo does not provide this info
    isBluetooth: false, // Evo does not provide this info
  };
};
